export enum TicketScheduledStatuses {
    NON_ASSEGNATO = 'Non Assegnato',
    ASSEGNATO = 'Assegnato',
    RIFIUTATO = 'Rifiutato',
    ONLINE = 'In Corso'
}